import axios from 'axios';
import { getSession, signIn } from 'next-auth/react';
import { shared } from '../config';

const BASE =
  (shared.OLLIE_ENV === 'local' ? 'http://' : 'https://') + shared.API_BASE_URL;

export const client = axios.create({
  baseURL: shared.OLLIE_ENV === 'test' ? '' : BASE,
  headers: {
    'X-Referer':
      typeof window !== 'undefined' ? window.location.href : 'https://node',
  },
});
export const register = async ({ firstName, email }) => {
  const results = await signIn('register', {
    first_name: firstName,
    email,
    redirect: false,
  });

  // If we successfully sign in, clear the token.
  if (results.ok && !results.error) {
    token = null;
  }

  return results;
};

let token = null;

/**
 * Saves the token in the module scope. If it is already saved, use it.
 * If it isn't, attempt to fetch it & save it if we find it so we don't
 * have to fetch it again.
 * @returns {Promise<string | null>}
 */
const getToken = async () => {
  if (token == null) {
    const session = await getSession();
    token = session?.user?.access_token ?? null;
  }
  return token;
};

/**
 * @param {import('axios').AxiosRequestConfig} request
 */
const ensureAccessToken = async request => {
  try {
    const token = await getToken();

    if (token) {
      request.headers['Authorization'] = `Bearer ${token}`;
    }
  } catch {
    // ignore
  }

  return request;
};

client.interceptors.request.use(ensureAccessToken);
